<template>
  <v-layout
    row
    wrap
    style="padding: 0 0  0 20px; "
  >
    <v-flex
      xs4
      4
    >
      <v-dialog
        ref="dialogStartDate"
        v-model="modalStartDate"
        :return-value.sync="editTMP.StartDate"
        persistent
        full-width
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="editTMP.StartDate"
            :label="$t('menus.availability.startDate')"
            prepend-icon="mdi-calendar-clock"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="editTMP.StartDate"
          :locale="locale"
          scrollable
          dark
          @input="handleEmit"
        >
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="modalStartDate = false"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialogStartDate.save(editTMP.StartDate)"
          >
            {{ $t('common.ok') }}
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
    <v-flex
      xs4
      4
    >
      <v-dialog
        v-if="!editTMP.NoEndDate"
        ref="dialogEndDate"
        v-model="modalEndDate"
        :return-value.sync="editTMP.EndDate"
        persistent
        full-width
        width="290px"
      >
        <template
          v-slot:activator="{ on }"
        >
          <v-text-field
            v-model="editTMP.EndDate"
            :label="$t('menus.availability.endDate')"
            prepend-icon="mdi-calendar-clock"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="editTMP.EndDate"
          scrollable
          dark
          @input="handleEmit"
        >
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="modalEndDate = false"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialogEndDate.save(editTMP.EndDate)"
          >
            {{ $t('common.ok') }}
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
    <v-flex
      xs4
      4
      style="padding-left: 10px;"
    >
      <v-checkbox
        v-model="editTMP.NoEndDate"
        :label="$t('menus.availability.noEndDate')"
        @change="handleEmit"
      />
    </v-flex>
    
  </v-layout>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    props: {
      editTMP: {
        type: Object,
        require: true
      }
    },
    data () {
      return {
        modalStartDate: false,
        modalEndDate: false
      }
    },
    computed: {
      ...mapState('app',['locale']),
    },
    methods: {
      handleEmit () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>
